"use client";

import posthog from "posthog-js";
import { withReferral } from "@/lib/referral";

interface PartnerLinkProps {
  /** Partner's website URL — referral tracking params are added automatically. */
  href: string;
  /** Partner business name, recorded with the click for per-partner reporting. */
  partner: string;
  /** Optional extra detail recorded with the click (e.g. suite number). */
  suite?: string;
  className?: string;
  "aria-label"?: string;
  children: React.ReactNode;
}

/**
 * Outbound link to a Simply Health Center partner business.
 *
 * Adds UTM referral parameters to the destination so the partner's own
 * analytics can attribute the visit to Simply Health Rx, and records a
 * `partner_referral_click` event in PostHog so we can report how many visitors
 * we send each partner — the proof behind paid referral arrangements.
 */
export function PartnerLink({
  href,
  partner,
  suite,
  className,
  children,
  ...rest
}: PartnerLinkProps) {
  return (
    <a
      href={withReferral(href)}
      target="_blank"
      rel="sponsored noopener noreferrer"
      className={className}
      onClick={() =>
        posthog.capture("partner_referral_click", {
          partner,
          suite,
          destination: href,
        })
      }
      {...rest}
    >
      {children}
    </a>
  );
}
